import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-course-equalization-return',
    templateUrl: './course-equalization-return.component.html'
})
export class CourseEqualizationReturnComponent {
    constructor(
        private activeModal: NgbActiveModal
    ) { }

    comment: string;

    ok() {
        this.activeModal.close({
            comment: this.comment
        });
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
